<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = false,
		disabled = false,
		error = null,
		label = null,
		...props
	} = $props();
</script>

<InputWrapper {label} {error} class={className}>
	<input
		bind:value
		bind:this={element}
		type="text"
		class={[
			'border-indow-grey-light w-full content-center rounded-md',
			{ 'bg-indow-grey-light cursor-not-allowed': disabled },
			{ 'border-indow-red': error },
		]}
		aria-invalid={error ? true : undefined}
		{name}
		{required}
		{disabled}
		{...props}
	/>
</InputWrapper>
